const initialState = {
  settingsTestsList: [],
};

export const settingsTestsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "settings/tests")
    return action.execute(state);
  return state;
};
